<template>
    <div>
      <component 
            v-bind:is="thiscomponent"
            v-bind:locationselect="locationselect"
            v-bind:locations="locations"
            v-bind:heatmaplocations="heatmaplocations"
            :key="componentKey"
        />
    </div>
</template>
<script>
import axios from "axios";
import MarketResearchMap from "./MarketResearchMap.vue";
export default {
  name: "Report Shell Map",
  components: { MarketResearchMap },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    }
  },
  data() {
    return {
      componentKey: 0,
      thiscomponent: MarketResearchMap,
      locations: [],
      heatmaplocations: []
    };
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
  },
  mounted() {
    axios
      .get("/user_report", {
        params: { report: this.passedData + ".csv.mapPoints.json", format: "html" },
      })
      .then((response) => {
        this.locations = response.data[1].map(([lat, lng]) => ({ lat, lng }));
        this.forceRerender();
        console.log('test locations '+JSON.stringify(this.locations));
      });
  },
};
</script>